import { addLocale, locale } from "primereact/api";

const PRIME_REACT_AR_LOCALE = {
  firstDayOfWeek: 0,
  dayNames: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
  dayNamesShort: ["أحد", "اثن", "ثلا", "أرب", "خمي", "جمع", "سبت"],
  dayNamesMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  monthNames: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
  monthNamesShort: [
    "ينا",
    "فبر",
    "مار",
    "أبر",
    "ماي",
    "يون",
    "يول",
    "أغس",
    "سبت",
    "أكت",
    "نوف",
    "ديس",
  ],
  today: "اليوم",
  clear: "مسح",
  now: "الآن",
  dateFormat: "dd/mm/yy",
  weekHeader: "أسبوع",
  chooseDate: "اختر التاريخ",
  chooseMonth: "اختر الشهر",
  chooseYear: "اختر السنة",
  prevMonth: "الشهر السابق",
  nextMonth: "الشهر التالي",
  prevYear: "السنة السابقة",
  nextYear: "السنة التالية",
  prevDecade: "العقد السابق",
  nextDecade: "العقد التالي",
  showMonthAfterYear: false,
  aria: {
    trueLabel: "صحيح",
    falseLabel: "خطأ",
    nullLabel: "غير محدد",
    star: "نجمة واحدة",
    stars: "{star} نجوم",
    selectAll: "تحديد الكل",
    unselectAll: "إلغاء تحديد الكل",
    close: "إغلاق",
    previous: "السابق",
    next: "التالي",
    navigation: "التنقل",
    scrollTop: "التمرير إلى الأعلى",
    moveTop: "نقل إلى الأعلى",
    moveUp: "نقل للأعلى",
    moveDown: "نقل للأسفل",
    moveBottom: "نقل إلى الأسفل",
    moveToTarget: "نقل إلى الهدف",
    moveToSource: "نقل إلى المصدر",
    moveAllToTarget: "نقل الكل إلى الهدف",
    moveAllToSource: "نقل الكل إلى المصدر",
    pageLabel: "الصفحة {page}",
    firstPageLabel: "الصفحة الأولى",
    lastPageLabel: "الصفحة الأخيرة",
    nextPageLabel: "الصفحة التالية",
    prevPageLabel: "الصفحة السابقة",
    rowsPerPageLabel: "عدد الصفوف في الصفحة",
    jumpToPageDropdownLabel: "انتقل إلى صفحة",
    jumpToPageInputLabel: "انتقل إلى صفحة",
    selectRow: "تحديد الصف",
    unselectRow: "إلغاء تحديد الصف",
    expandRow: "توسيع الصف",
    collapseRow: "طي الصف",
    showFilterMenu: "إظهار قائمة الفلترة",
    hideFilterMenu: "إخفاء قائمة الفلترة",
    filterOperator: "عامل الفلترة",
    filterConstraint: "قيد الفلترة",
    editRow: "تعديل الصف",
    saveEdit: "حفظ التعديل",
    cancelEdit: "إلغاء التعديل",
    listView: "عرض القائمة",
    gridView: "عرض الشبكة",
    slide: "شريحة",
    slideNumber: "{slideNumber}",
    zoomImage: "تكبير الصورة",
    zoomIn: "تكبير",
    zoomOut: "تصغير",
    rotateRight: "تدوير لليمين",
    rotateLeft: "تدوير لليسار",
  },
};

let primeReactLocalesRegistered = false;

export const registerPrimeReactLocales = () => {
  if (primeReactLocalesRegistered) {
    return;
  }

  addLocale("ar", PRIME_REACT_AR_LOCALE);
  primeReactLocalesRegistered = true;
};

export const getPrimeReactLocale = (language) => (language === "ar" ? "ar" : "en");

export const getPrimeReactDateFormat = (language) =>
  getPrimeReactLocale(language) === "ar" ? "dd/mm/yy" : "mm/dd/yy";

export const syncPrimeReactLocale = (language) => {
  registerPrimeReactLocales();
  const nextLocale = getPrimeReactLocale(language);
  locale(nextLocale);
  return nextLocale;
};

registerPrimeReactLocales();
